(function () {
  this.SlideService = function (plugin) {
    this.plugin = plugin;
  };

  this.SlideService.prototype.MarkUserSlides = function () {
    var uploadedLanes = this.plugin.UserData.GetUploadedLanes();
    for (var index = 0; index < uploadedLanes.length; index++) {
      var laneId = uploadedLanes[index];
      var lane = document.querySelector(
        '.' +
          this.plugin.Config.classNames.slide.base +
          '[data-id="' +
          laneId +
          '"]'
      );
      if (lane) {
        lane.classList.add(this.plugin.Config.classNames.slide.userUploaded);
      }
    }
  };
}).bind(window.WorstCyclingLane)();
